// extracted by mini-css-extract-plugin
export var altButtonStyle = "index-module--altButtonStyle--Y1cB6";
export var defaultButtonStyle = "index-module--defaultButtonStyle--u-+it";
export var sevenColumnImageColumn = "index-module--sevenColumnImageColumn--jSmDN";
export var sevenColumnImageColumnContainer = "index-module--sevenColumnImageColumnContainer--TQ8+7";
export var sevenColumnImageDark = "index-module--sevenColumnImageDark--2KQ5H";
export var sevenColumnImageHeadingContainer = "index-module--sevenColumnImageHeadingContainer--t5zQb";
export var sevenColumnImageImageContainer = "index-module--sevenColumnImageImageContainer--xke5s";
export var sevenColumnImageInnerContainer = "index-module--sevenColumnImageInnerContainer--05JAa";
export var sevenColumnImageLeft = "index-module--sevenColumnImageLeft--sV7Bq";
export var sevenColumnImageOuterContainer = "index-module--sevenColumnImageOuterContainer--njTJm";
export var sevenColumnImageRight = "index-module--sevenColumnImageRight--2UsiL";
export var sevenColumnTextColumn = "index-module--sevenColumnTextColumn--TJGpZ";